import { render, staticRenderFns } from "./MatTypeInfo.vue?vue&type=template&id=164e1f96&scoped=true&"
import script from "./MatTypeInfo.vue?vue&type=script&lang=ts&"
export * from "./MatTypeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MatTypeInfo.vue?vue&type=style&index=0&id=164e1f96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e1f96",
  null
  
)

export default component.exports